import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class DocumentLinkUploadContextService {
  private closeHandler: (() => void) | null = null;
  private uploadHandler: ((files: File[]) => Promise<void>) | null = null;
  private pendingFiles: File[] | null = null;

  registerDialog(ref: MatDialogRef<any>) {
    this.closeHandler = () => ref.close();
  }

  unregisterDialog() {
    this.closeHandler = null;
  }

  registerUploadHandler(handler: ((files: File[]) => Promise<void>) | null) {
    this.uploadHandler = handler;
  }

  hasUploadHandler() {
    return !!this.uploadHandler;
  }

  async uploadFiles(files: File[]) {
    await this.uploadHandler?.(files);
  }

  setPendingFiles(files: File[] | null) {
    this.pendingFiles = files ? [...files] : null;
  }

  consumePendingFiles(): File[] | null {
    const files = this.pendingFiles;
    this.pendingFiles = null;
    return files ? [...files] : null;
  }

  closeActiveDialog() {
    const handler = this.closeHandler;
    this.closeHandler = null;
    handler?.();
  }
}
